import { useState, useEffect } from 'react';
import { getNativeLocalStorage, safeLocalStorage } from '../utils/safeStorage';

// ----------------------------------------------------------------------

export default function useLocalStorage(key, defaultValue) {
  const [value, setValue] = useState(() => {
    const storedValue = safeLocalStorage.getItem(key);

    if (storedValue === null) return defaultValue;

    try {
      return JSON.parse(storedValue);
    } catch {
      return defaultValue;
    }
  });

  useEffect(() => {
    const listener = (e) => {
      if (e.storageArea === getNativeLocalStorage() && e.key === key) {
        try {
          setValue(e.newValue === null ? defaultValue : JSON.parse(e.newValue));
        } catch {
          setValue(defaultValue);
        }
      }
    };
    window.addEventListener('storage', listener);

    return () => {
      window.removeEventListener('storage', listener);
    };
  }, [key, defaultValue]);

  const setValueInLocalStorage = (newValue) => {
    setValue((currentValue) => {
      const result =
        typeof newValue === 'function' ? newValue(currentValue) : newValue;

      safeLocalStorage.setItem(key, JSON.stringify(result));

      return result;
    });
  };

  return [value, setValueInLocalStorage];
}
